__webpack_require__.p = "/patissier-portfolio/";